import { render, staticRenderFns } from "./ListFacturas.vue?vue&type=template&id=29bf8cc1&scoped=true"
import script from "./ListFacturas.vue?vue&type=script&lang=js"
export * from "./ListFacturas.vue?vue&type=script&lang=js"
import style0 from "./ListFacturas.vue?vue&type=style&index=0&id=29bf8cc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bf8cc1",
  null
  
)

export default component.exports